export default __webpack_public_path__ + "offerBoxes.png";